module.exports = __webpack_public_path__ + "img/mobileMenu.814b8b64.png";